import { CheckCircle2 } from 'lucide-react';

import type { AiModel, ModelTestResult } from '@/api/types';
import { formatUsd } from '@/ui/format';
import { Modal } from '@/ui/Modal';

import { testFailure } from './modelList';

/** The outcome of a row's Test: the reply and its cost, or the provider's error. */
export function TestResultDialog({
  model,
  pending,
  result,
  error,
  onClose,
}: {
  model: AiModel;
  pending: boolean;
  result?: ModelTestResult;
  error: Error | null;
  onClose: () => void;
}) {
  const failure = testFailure(error, result);
  return (
    <Modal
      title={`Test ${model.display_name}`}
      subtitle={model.model_id}
      size="narrow"
      onClose={onClose}
      footer={
        <button type="button" className="btn btn-primary" onClick={onClose}>
          Close
        </button>
      }
    >
      <div aria-live="polite">
        {pending && <p className="hint">Sending a one-line prompt through the real pipeline…</p>}
        {!pending && failure && (
          <div className="alert alert-warning form-alert" role="alert">
            <div className="a-body">
              <b>The test failed.</b> {failure}
            </div>
          </div>
        )}
        {!pending && result?.ok && (
          <div className="stack-md">
            <span className="status-ok row"><CheckCircle2 aria-hidden="true" /> The model answered: “{result.text}”</span>
            <p className="hint">
              {result.latency_ms} ms · {result.tokens_input} tokens in / {result.tokens_output} out · {formatUsd(result.cost_usd)}, billed and
              logged in AI usage.
            </p>
          </div>
        )}
      </div>
    </Modal>
  );
}
